module.exports = require("./es-CR.d.ts");